angular.module('iqxCore')
.controller('ChangePasswordCtrl', function ($scope, $location, FormSvc, ApplicationSvc, pinSvc) {
   FormSvc.setOptions($scope,{
      fetchAPI:{}, // No data fetch - initialise with empty record
      autoEdit:true, // Switch form straight to edit mode
      })
  
  $scope.save=function () {
    $scope.setSubmitted(true) // Ensure all validation errors appear
    if ($scope.theForm.$invalid) {return}
    $scope.exec('auth/changepassword',$scope.theRecord)
    .then(function(res) {
      return ApplicationSvc.changePassword(res)
    })
    .then(function(){
      pinSvc.destroy()
      $scope.usingpinauth=false
      FormSvc.alert("Updated", "Your password has been updated.", "success")
      $scope.$evalAsync(function(){ 
        var p=ApplicationSvc.postLoginRoute // If this is a forced password change navigate to wherever was last requested in the un-loggedin state (default=/)
        ApplicationSvc.postLoginRoute='/'   // Reset the default
        $location.path(p) 
      })      
    })
  }
  $scope.forceChangePassword=ApplicationSvc.forceChangePassword()
  $scope.passwordOpts()
  $scope.fetch()  // Complete the initialise
    
})
